module.exports = __webpack_public_path__ + "fonts/SamsungOne-700_v1.1.d6b71506.ttf";